import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import FloatingWhatsApp from '@/components/FloatingWhatsApp';
import MortgageWidget from '@/components/MortgageWidget';
import ComparisonFloat from '@/components/ComparisonFloat';
import EverAIAssistant from '@/components/EverAIAssistant';
import Breadcrumbs from '@/components/Breadcrumbs';
import { useLocation } from 'react-router-dom';

const PublicLayout = () => {
    const location = useLocation();
    const isHome = location.pathname === '/';

    return (
        <>
            <Header />
            <main>
                {!isHome && <Breadcrumbs />}
                <Outlet />
            </main>
            <Footer />
            <FloatingWhatsApp />
            <MortgageWidget />
            <ComparisonFloat />
            <EverAIAssistant />
        </>
    );
};

export default PublicLayout;
